import React from 'react';
import { useTranslation } from 'react-i18next';
import { ICheckboxProps } from '../../types/input.type';
import { CheckBoxIcon } from '../icons/checkbox-icon.component';

export const CheckBox = ({ description, register, terms }: ICheckboxProps) => {
  const { t } = useTranslation();
  return (
  <label className="flex items-center gap-[8px] mt-[4px] cursor-pointer select-none">
    <div className="relative flex items-center justify-center">
      <input
        type="checkbox"
        className="peer appearance-none h-[20px] w-[20px] rounded-[4px] border border-base-black
      transition-all duration-200 cursor-pointer
      checked:bg-blue-500 checked:border-blue-600
      hover:bg-blue-100 hover:border-blue-500"
        {...register()}
      />

      <div className="absolute inset-0 flex items-center justify-center opacity-0 peer-checked:opacity-100 pointer-events-none">
        <CheckBoxIcon />
      </div>
    </div>

    {terms ? (
      <span className="text-base-black font-body text-[16px] font-regular leading-[140%]">
        {t('auth.agreeToTerms')}{' '}
        <a
          href="/terms"
          className="text-blue-700 underline hover:text-blue-800"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          {t('auth.termsOfService')}
        </a>
        {' '}{t('auth.and')}{' '}
        <a
          href="/privacy"
          className="text-blue-700 underline hover:text-blue-800"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          {t('auth.privacyPolicy')}
        </a>
      </span>
    ) : (
      <span className="text-base-black font-body text-[16px] font-regular leading-[140%]">
        {description}
      </span>
    )}
  </label>
  );
};
